/* eslint-disable consistent-return */
/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  Grid,
  Dropdown,
  Divider,
  List,
  Form,
  Image,
  Checkbox,
  Label,
  Popup,
  Button
} from 'semantic-ui-react';
import 'react-day-picker/lib/style.css';
import './PackageLaunch.css';
import constants from './constants/constants';
import Images from '../../assets/Images';
import {
  getProperThumbnail,
  getProperCarouselCardThumbnail
} from '../../utils/thumbnailRecovery';

class PackageLaunchAdSectionComponent extends Component {
  state = {
    cardThumbnails: [],
    currentSingleThumbnails: [],
    openTooManyVideosWarning: false,
    activeThumbnailAdIds: []
  };

  componentDidMount() {
    const { packageToLaunch, onRef, fbToken } = this.props;
    const { adsets, ads } = packageToLaunch;

    if (onRef) onRef(this);

    adsets.forEach((adSet) => {
      ads
        .filter((item) => item.adSetId === adSet.id)
        .forEach((ad) => {
          const currentAd = ad.ad;
          this.getProperThumbnail(currentAd, fbToken);
        });
    });
  }

  getProperThumbnail = async (currentAd, fbToken) => {
    if (currentAd.type === 'Carousel') {
      await Promise.all(
        currentAd.cards.map(async (card) => {
          await getProperCarouselCardThumbnail(
            card,
            this.setCardThumbnailArrayState,
            fbToken
          );
        })
      );
    } else if (
      ['Collection', 'Video', 'Cinemagraph'].includes(currentAd.type)
    ) {
      await getProperThumbnail(
        currentAd,
        'ad',
        this.setThumbnailArrayState,
        fbToken
      );
    }
  };

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  setCardThumbnailArrayState = (id, thumbnail) => {
    const { cardThumbnails } = this.state;
    const newThumbnails = cardThumbnails;
    const newThumbnailObj = {
      id,
      thumbnail:
        thumbnail && thumbnail.trim() !== ''
          ? thumbnail
          : Images.missingThumbnail
    };

    const foundIndex = newThumbnails.findIndex((newThumbnail) => {
      return newThumbnail.id === id;
    });

    if (foundIndex !== -1) {
      if (newThumbnails[foundIndex].thumbnail.includes('missingThumbnail')) {
        newThumbnails[foundIndex].thumbnail = thumbnail;
        this.setState({ cardThumbnails: newThumbnails });
      }
    } else {
      this.setState({
        cardThumbnails: this.state.cardThumbnails.concat([newThumbnailObj])
      });
    }

    return thumbnail;
  };

  setThumbnailArrayState = (adId, thumbnail) => {
    const { currentSingleThumbnails } = this.state;
    const newSingleThumbnails = currentSingleThumbnails;
    const newThumbnailObj = {
      adId,
      thumbnail
    };

    const foundThumbnailIndex = newSingleThumbnails.indexOf(
      (singleThumbnailObj) => {
        return singleThumbnailObj.adId === adId;
      }
    );

    if (foundThumbnailIndex !== -1) {
      newSingleThumbnails.splice(foundThumbnailIndex, 1);
    }
    newSingleThumbnails.concat([newThumbnailObj]);

    this.setState({
      currentSingleThumbnails: newSingleThumbnails
    });
  };

  setThumbnailArrayState = (id, thumbnail) => {
    const { currentSingleThumbnails } = this.state;
    const newThumbnails = currentSingleThumbnails;
    const newThumbnailObj = {
      id,
      thumbnail:
        thumbnail && thumbnail.trim() !== ''
          ? thumbnail
          : Images.missingThumbnail
    };

    const foundIndex = newThumbnails.findIndex((newThumbnail) => {
      return newThumbnail.id === id;
    });

    if (foundIndex !== -1) {
      if (newThumbnails[foundIndex].thumbnail.includes('missingThumbnail')) {
        newThumbnails[foundIndex].thumbnail = thumbnail;
        this.setState({ currentSingleThumbnails: newThumbnails });
      }
    } else {
      this.setState({
        currentSingleThumbnails: this.state.currentSingleThumbnails.concat([
          newThumbnailObj
        ])
      });
    }

    return thumbnail;
  };

  getCardMatchingThumbnail = (id) => {
    const { cardThumbnails } = this.state;
    const foundThumbnailObj = cardThumbnails.find((thumbnailObj) => {
      return thumbnailObj.id === id;
    });
    const thumbnail = foundThumbnailObj
      ? foundThumbnailObj.thumbnail
      : Images.missingThumbnail;
    return thumbnail;
  };

  getMatchingAdThumbnail = (adId) => {
    const { currentSingleThumbnails } = this.state;
    if (currentSingleThumbnails.length > 0) {
      const foundThumbnailObj = currentSingleThumbnails.find((thumbnailObj) => {
        return thumbnailObj.id === adId;
      });
      if (foundThumbnailObj) {
        return foundThumbnailObj.thumbnail;
      }
    }
  };

  toggleTooManyVideoWarning = () => {
    const { openTooManyVideosWarning } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      openTooManyVideosWarning: !openTooManyVideosWarning
    }));
  };

  tooManyVideosWarningPopupStyle = (numberOfVideoCards) => {
    const style =
      numberOfVideoCards >= 5 ? { color: 'red' } : { color: 'black' };
    return style;
  };

  countVideoCards = (cards) => {
    let videoCounter = 0;
    cards.forEach((card) => {
      const { video } = card;
      if (video && video.trim() !== '') {
        videoCounter = videoCounter + 1;
      }
    });
    return videoCounter;
  };

  render() {
    const { openTooManyVideosWarning } = this.state;
    const {
      form,
      packageToLaunch,
      productSets,
      productCatalogs,
      duplicateAdCounters,
      duplicateAdFormData,
      resetAdFormData,
      onAdCheck,
      handleAdCardChange,
      handleAdChange,
      onProductCatalogSelectionChangeAd,
      onProductSetSelectionChangeAd
    } = this.props;
    const {
      CANVAS,
      CAROUSEL,
      DAA,
      COLLECTION,
      STILL,
      VIDEO,
      CINEMAGRAPH
    } = constants.LAUNCHER;

    return (
      <div className="launch-package-ads-section">
        <div>
          <Popup
            on="hover"
            content="Click this button to clear the Ad fields"
            position="top left"
            trigger={
              <Label
                style={{ paddingRight: 0 }}
                as="a"
                color="orange"
                icon="erase"
                size="mini"
                onClick={resetAdFormData}
              />
            }
          />
          <Button
            color="violet"
            size="mini"
            style={{ marginLeft: '1.5em' }}
            onClick={() => {
              const adIds = packageToLaunch.ads.map((ad) => ad.id);
              const activeAdIds =
                this.state.activeThumbnailAdIds.length === adIds.length
                  ? []
                  : adIds;

              this.setState({
                ...this.state,
                activeThumbnailAdIds: activeAdIds
              });
            }}
          >
            Hide/Show all thumbnails
          </Button>
        </div>
        {packageToLaunch.adsets.map((adSet, adsetIndex) => (
          <List.Item
            className="launch-package-ad-container"
            key={`${adSet.id}-ad-container`}
          >
            <span className="input-title">
              <b>{adSet.adSetName}</b>
            </span>
            <List.Item className="launch-package-ad-container">
              {packageToLaunch.ads.filter((item) => item.adSetId === adSet.id)
                .length === 0 ? (
                <span className="launch-package-emtpy-ads-message">
                  The Ad Set has no Ads
                </span>
              ) : null}
              {packageToLaunch.ads
                .filter((item) => item.adSetId === adSet.id)
                .map((ad, adIndex) => {
                  const { id: adId, ad: innerAd, name } = ad;
                  const { id: innerAdId, cards, type, thumbnail } = innerAd;

                  const adInForm = form.ads.find((tmp) => tmp.id === adId);

                  const { destinationUrl: url, cards: formCards } =
                    adInForm || {};
                  const { productCatalog, productSet, footerUrl } =
                    adInForm || {};

                  const productSetOptions = productSets[adId];
                  let counter = 0;
                  if (duplicateAdCounters.length > 0) {
                    const testCounter = duplicateAdCounters.find(
                      (adCounter) => adCounter.adId === innerAdId
                    );
                    counter = testCounter.count;
                  }
                  const numberOfVideoCards = cards
                    ? this.countVideoCards(cards)
                    : 0;
                  return (
                    <div key={`${adId}-launch-ad-container`}>
                      <div className="launch-ad-container">
                        <Divider hidden />
                        <div style={{ height: 'fit-content' }}>
                          <Grid
                            verticalAlign="middle"
                            stackable
                            columns="equal"
                          >
                            <Grid.Row>
                              <Grid.Column style={{ paddingLeft: 0 }}>
                                <Checkbox
                                  defaultChecked
                                  style={{ float: 'right' }}
                                  adId={adId}
                                  onClick={onAdCheck}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                              <Grid.Column style={{ paddingLeft: 0 }}>
                                <Popup
                                  content="By clicking this button, you can copy the form data to this ad's duplicates"
                                  on="hover"
                                  position="top left"
                                  trigger={
                                    <Label
                                      style={{ float: 'right' }}
                                      as="a"
                                      color="blue"
                                      content={counter || 0}
                                      icon="clone"
                                      onClick={() =>
                                        duplicateAdFormData(
                                          adId,
                                          innerAdId,
                                          type
                                        )
                                      }
                                    />
                                  }
                                />
                                <Divider hidden />
                                {type === CAROUSEL ? (
                                  <Popup
                                    style={this.tooManyVideosWarningPopupStyle(
                                      numberOfVideoCards
                                    )}
                                    position="bottom left"
                                    content={`Because of the current limitations of the FB API, it is recommended that there be only 
                                              5 videos MAXIMUM in a carousel ad. Otherwise, the ad will likely not launch, either by
                                              itself or in a package.`}
                                    trigger={
                                      <Button
                                        style={{ float: 'right' }}
                                        color={
                                          numberOfVideoCards >= 5 ? 'red' : ''
                                        }
                                        icon="info circle"
                                        onClick={this.toggleTooManyVideoWarning}
                                      />
                                    }
                                    open={openTooManyVideosWarning}
                                  />
                                ) : null}
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </div>
                        <div className="launch-ad-item-container">
                          <Label
                            basic
                            style={{ width: '100%' }}
                            onClick={
                              type !== CAROUSEL
                                ? (event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    const newAdIds = this.state
                                      .activeThumbnailAdIds;
                                    this.setState({
                                      ...this.state,
                                      activeThumbnailAdIds: newAdIds.includes(
                                        adId
                                      )
                                        ? newAdIds.filter((id) => id !== adId)
                                        : [...newAdIds, adId]
                                    });
                                  }
                                : undefined
                            }
                          >
                            {name}
                          </Label>
                          {type !== CAROUSEL ? (
                            <div>
                              <Divider hidden />
                              <Image
                                className="launch-package-ad-preview-image"
                                style={{
                                  display: this.state.activeThumbnailAdIds.includes(
                                    adId
                                  )
                                    ? 'none'
                                    : undefined
                                }}
                                src={
                                  type === STILL
                                    ? thumbnail
                                    : this.getMatchingAdThumbnail(innerAdId) ||
                                      thumbnail
                                }
                              />
                            </div>
                          ) : null}
                          {type === DAA ? (
                            <h1
                              style={{
                                display: this.state.activeThumbnailAdIds.includes(
                                  adId
                                )
                                  ? 'none'
                                  : undefined
                              }}
                              className="launch-ad-daa-title"
                            >
                              DAA
                            </h1>
                          ) : null}
                          <Divider hidden />
                        </div>
                        <div>
                          <div
                            style={{
                              paddinTop: '0.5em',
                              paddingLeft: '0.875em'
                            }}
                          >
                            {type !== DAA && adsetIndex === 0 && adIndex === 0 && (
                              <Popup
                                on="hover"
                                content={`Apply ${
                                  type === CAROUSEL
                                    ? 'first available'
                                    : 'current'
                                } URL value to all other URL inputs.`}
                                trigger={
                                  <Button
                                    compact
                                    color="blue"
                                    onClick={() => {
                                      let urlToUse;
                                      switch (type) {
                                        case CAROUSEL:
                                          urlToUse = formCards
                                            ? (
                                                formCards.find(
                                                  (card) => card.destinationUrl
                                                ) || {}
                                              ).destinationUrl
                                            : '';
                                          break;
                                        case COLLECTION:
                                          urlToUse = footerUrl;
                                          break;
                                        default:
                                          urlToUse = url;
                                          break;
                                      }
                                      if (!urlToUse) {
                                        toast.warn('The URL field is empty', {
                                          position: 'bottom-center',
                                          autoClose: 3000,
                                          hideProgressBar: true,
                                          closeOnClick: true,
                                          pauseOnHover: true,
                                          draggable: true
                                        });
                                      } else {
                                        this.props.handleAdsBatchChange({
                                          destinationUrl: urlToUse
                                        });
                                      }
                                    }}
                                  >
                                    Apply URL to All
                                  </Button>
                                }
                              />
                            )}
                          </div>
                          <br />
                          {type === CAROUSEL
                            ? cards.map((card) => {
                                const currentCard = formCards
                                  ? formCards.find(
                                      (tmpCard) => tmpCard.cardId === card.id
                                    )
                                  : undefined;

                                const { destinationUrl } = currentCard || {};

                                return (
                                  <div>
                                    <div className="carousel-card-image-container">
                                      <Grid padded="vertically" columns={6}>
                                        <Grid.Row
                                          verticalAlign="middle"
                                          stretched
                                        >
                                          <Grid.Column style={{ padding: 0 }}>
                                            <Image
                                              className="carousel-card-image"
                                              src={this.getCardMatchingThumbnail(
                                                card.id
                                              )}
                                            />
                                          </Grid.Column>
                                          <Grid.Column>
                                            <Form.Input
                                              style={{ maxWidth: '175px' }}
                                              className="carousel-card-ad-field"
                                              placeholder="Destination URL"
                                              type="text"
                                              name="destinationUrl"
                                              id={adId}
                                              adId={innerAdId}
                                              adSetId={adSet.id}
                                              cardId={card.id}
                                              value={destinationUrl}
                                              onChange={handleAdCardChange}
                                            />
                                          </Grid.Column>
                                        </Grid.Row>
                                      </Grid>
                                    </div>
                                    <Divider hidden />
                                  </div>
                                );
                              })
                            : null}
                          {type === CANVAS ? (
                            <Form.Input
                              className="launch-package-ad-field"
                              placeholder="Destination URL"
                              type="text"
                              name="destinationUrl"
                              id={adId}
                              adSetId={adSet.id}
                              value={url}
                              adId={innerAdId}
                              onChange={handleAdChange}
                            />
                          ) : null}

                          {type === VIDEO || type === CINEMAGRAPH ? (
                            <Form.Input
                              className="launch-package-ad-field"
                              placeholder="Destination URL"
                              type="text"
                              name="destinationUrl"
                              id={adId}
                              adId={innerAdId}
                              adSetId={adSet.id}
                              value={url}
                              onChange={handleAdChange}
                            />
                          ) : null}

                          {type === STILL ? (
                            <Form.Input
                              className="launch-package-ad-field"
                              placeholder="Destination URL"
                              type="text"
                              name="destinationUrl"
                              id={adId}
                              adId={innerAdId}
                              adSetId={adSet.id}
                              value={url}
                              onChange={handleAdChange}
                            />
                          ) : null}

                          {type === COLLECTION ? (
                            <div>
                              <Form.Input
                                className="launch-package-ad-field"
                                placeholder="Footer Url"
                                type="text"
                                name="footerUrl"
                                id={adId}
                                adId={innerAdId}
                                adSetId={adSet.id}
                                value={footerUrl}
                                onChange={handleAdChange}
                              />
                              <Dropdown
                                placeholder="Product Catalog"
                                className="launch-package-ad-field"
                                search
                                selection
                                id={adId}
                                adId={innerAdId}
                                adSetId={adSet.id}
                                name="productCatalog"
                                options={productCatalogs}
                                value={productCatalog}
                                onChange={onProductCatalogSelectionChangeAd}
                              />
                              <br />
                              <Dropdown
                                placeholder="Product set"
                                className="launch-package-ad-field"
                                search
                                selection
                                id={adId}
                                adId={innerAdId}
                                name="productSet"
                                adSetId={adSet.id}
                                options={productSetOptions}
                                value={productSet}
                                onChange={onProductSetSelectionChangeAd}
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <Divider hidden />
                    </div>
                  );
                })}
              <Divider hidden />
            </List.Item>
          </List.Item>
        ))}
      </div>
    );
  }
}

export default PackageLaunchAdSectionComponent;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/PackageLaunchAdSectionComponent.js